import { useMemo } from 'react';
import { ChangelogServiceAPI, initChangelogService } from 'src/services/changelog.service';
import { getPersistentChangelogInitialState } from 'src/utils/changelog.utils';
import { changelog } from '../changelog/changelog';
import type { ChangeLogDialogLocalStorageState } from 'src/types/changeLog.types';

type ChangelogService = {
  initialState: ChangeLogDialogLocalStorageState;
  changelogService: ChangelogServiceAPI;
};

export const useChangelogService = (initialChangelogLocalStorage?: string): ChangelogService => {
  return useMemo((): ChangelogService => {
    const initialState = getPersistentChangelogInitialState(initialChangelogLocalStorage);

    const changelogService = initChangelogService({
      lastSeen: initialState.lastSeen ?? 0,
      showUnreadChanges: initialState.showUnreadChanges ?? true,
      changelog,
    });

    return { initialState, changelogService };
  }, [initialChangelogLocalStorage]);
};
